module.exports = __webpack_public_path__ + "img/esxi-logo.dfeb2938.png";